import React from 'react';
import ReactApexChart from 'react-apexcharts';
import '../Charts/charts.modules.scss';

const PlatformEarningBarChart = ({values, labels}: {values:any[], labels:string[]}) => {
  const options : ApexCharts.ApexOptions | undefined = {
    chart: {
        type: 'area',
        height: 'auto',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      plotOptions: {
      },
      xaxis: {
        type: 'category',
        labels: {
          style: {
              cssClass: 'apex-chart-custom-ltr',
          },
        },
        categories: labels,
        tickPlacement: 'between',
      },
      yaxis: {
        decimalsInFloat: 0,
        labels: {
          show: true,
          align: 'center',
        },
      },
      legend: {
        position: 'bottom',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        colors: ["#7066FF"],
        width: 1,
      },
      fill: {
        type: "gradient",
        gradient: {
            shade: 'dark',
            type: "horizontal",
            shadeIntensity: 0,
            gradientToColors: ["#7066FF"], // optional, if not defined - uses the shades of same color in series
            inverseColors: false,
            opacityFrom: 0.3,
            opacityTo: 0.5,
            stops: [0, 1],
        },
      },
    tooltip: {
      custom: function({series, seriesIndex, dataPointIndex, w}:any) {
        return '<div className="test">' +
        '<p className="serie">' + w.config.series[seriesIndex].name + ' </p>' +
        '<span className="category">' + w.config.series[seriesIndex].data[dataPointIndex].toLocaleString() + '</span>' +
          '</div>';
      },
    },
  };
  return (
    <div className="chart" id="lineChart" style={{height: '300px'}}>
      <ReactApexChart options={options} series={values} type="area" width="100%" height="100%" />
    </div>
  );
};

export default PlatformEarningBarChart;
